import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IWhyNeedSdelkaLayoutProps {
  title?: string;
}

export const WhyNeedSdelkaLayout: React.FC<IWhyNeedSdelkaLayoutProps & React.PropsWithChildren> = ({
  title = 'Зачем вам Сделка',
  children,
}) => {
  return (
    <section>
      <UIHeading1 as="h2" color="text-primary-default">
        {title}
      </UIHeading1>

      <div className={styles['wrapper']}>{children}</div>
    </section>
  );
};
